import { Checkbox } from "@/components/ui/checkbox";
import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormMessage,
} from "@/components/ui/form";
import { Label } from "@/components/ui/label";
import { isRequired } from "@/lib/form";
import { useTranslation } from "react-i18next";
import { ZodObject, ZodRawShape } from "zod";
import { Required } from "@/components/Required";

interface PayrollTypeHoursBoundToVisitsFieldProps {
  ns: string;
  schema: ZodObject<ZodRawShape>;
  disabled?: boolean;
}

export default function PayrollTypeHoursBoundToVisitsField({
  ns,
  schema,
  disabled = false,
}: PayrollTypeHoursBoundToVisitsFieldProps) {
  const { t } = useTranslation();

  return (
    <div className="col-span-full">
      <FormField
        name="hours_bound_to_visits"
        render={({ field }) => (
          <FormItem className="flex flex-col pt-6">
            <FormControl>
              <Label className="flex items-center font-normal">
                <Checkbox
                  className="mr-2"
                  checked={field.value}
                  onCheckedChange={field.onChange}
                  disabled={disabled}
                  {...field}
                />
                {t(`${ns}.fields.hours_bound_to_visits`)}
                {isRequired(schema.shape.hours_bound_to_visits) && <Required />}
              </Label>
            </FormControl>
            <FormDescription>
              {t(`${ns}.fields.hours_bound_to_visits.description`)}
            </FormDescription>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  );
}
